import {createContext} from 'react'; 
const context=createContext(0);
export default context;